<template>
  <confirm-dialog hide-actions :show="hideDialog" @shown="shown">
    <template #activator="{ on, attrs }">
      <slot name="activator" v-bind:attrs="attrs" v-bind:on="on">
        <v-btn small icon color="primary" class="ml-2 pl-0 pr-0" v-bind="attrs" v-on="on">
          <v-icon>mdi-account-arrow-up-outline</v-icon>
        </v-btn>
      </slot>
    </template>
    <template #title>
      {{ $t("remittances-.reasign") }}
    </template>
    <validation-observer ref="observer" v-slot="{ valid }">
      <v-form @submit.prevent="submit" class="mt-2">
        <v-row no-gutters>
          <v-col>
            <validation-provider
              v-slot="{ errors }"
              :name="$t('reseller').toLowerCase()"
              :rules="{ required: true }"
            >
              <v-select
                v-model="request.reseller"
                outlined
                item-value="id"
                item-text="name"
                :items="resellers"
                :label="$t('reseller')"
                :error-messages="errors"
              >
                <template #selection="{ item }">
                  {{ `${item.name} - ${$t(item.email)}` }}
                </template>
                <template #item="{ item }">
                  {{ `${item.name} - ${$t(item.email)}` }}
                </template>
              </v-select>
            </validation-provider>
          </v-col>
        </v-row>
        <v-row class="mt-0">
          <v-col>
            <v-btn block color="primary" type="submit" :disabled="!valid" elevation="0">
              {{ $t("submit") }}
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
    </validation-observer>
  </confirm-dialog>
</template>

<script>
import ConfirmDialog from "../components/ConfirmDialog";
import remittances from "../../requests/remittances";
import users from "../../requests/users";

export default {
  components: {
    ConfirmDialog,
  },
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    requestBase: {
      reseller: null,
    },
    request: null,
    hideDialog: false,
    resellers: [],
  }),
  created: async function () {
    this.resetForm();
  },
  methods: {
    shown: async function () {
      this.hideDialog = false;
      this.resellers = this.resellers.length == 0 ? await users.resellers() : this.resellers;
      if (this.resellers.length > 0) {
        this.request.reseller = this.resellers[0].id;
      }
    },
    submit: async function () {
      try {
        await remittances.reasign(this.item.id, this.request);
        await this.$store.dispatch("notificator/success", this.$t("succeeded_operation"));
        this.resetForm();
        this.$emit("reasigned");
        this.hideDialog = true;
      } catch (e) {
        if (e.response.status == 402) {
          await this.$store.dispatch("notificator/error", this.$t("remittances-.not-available-credit"));
        } else {
          await this.$store.dispatch("notificator/errorResponse", e);
        }
      }
    },
    resetForm: async function () {
      this.request = Object.assign({}, this.requestBase);
      if (this.$refs.observer) this.$refs.observer.reset();
    },
  },
};
</script>
